import { render, staticRenderFns } from "./applysettItem.vue?vue&type=template&id=2888ed82&scoped=true&"
import script from "./applysettItem.vue?vue&type=script&lang=js&"
export * from "./applysettItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888ed82",
  null
  
)

export default component.exports